import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { ProjectShareContent } from '../../components/guest/ProjectShareContent';

const ProjectSharePopupView = OptionPopupView.extend({

    "pageName": "Project Share Popup",

    initialize: function(options) {
        this._projectId = options.projectId;
        this._projectName = options.projectName;
        this._currentGuests = options.currentGuests || [];
        this._canInviteMoreGuests = options.canInviteMoreGuests !== undefined ? options.canInviteMoreGuests : true;
        this._isLoadingGuests = options.isLoadingGuests || false;
        this._guestLoadErrorMessage = options.guestLoadErrorMessage || null;
        this._onInvite = options.onInvite;
        this._onRevoke = options.onRevoke;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="project-share-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "500px");

        // Configure OptionPopupView
        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "ProjectSharePopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    updateGuests: function(guests, canInviteMoreGuests, guestLoadErrorMessage) {
        this._currentGuests = guests || [];
        if (canInviteMoreGuests !== undefined) {
            this._canInviteMoreGuests = canInviteMoreGuests;
        }
        this._guestLoadErrorMessage = guestLoadErrorMessage || null;
        this._isLoadingGuests = false;
        this._renderReactWidget();
    },

    onCancelTriggered: function() {
        this.close();
    },

    _renderReactWidget: function() {
        // Unmount existing component if any
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        // Create new React root and render component
        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(ProjectShareContent, {
                projectId: this._projectId,
                projectName: this._projectName,
                currentGuests: this._currentGuests,
                canInviteMoreGuests: this._canInviteMoreGuests,
                isLoading: this._isLoadingGuests,
                guestLoadErrorMessage: this._guestLoadErrorMessage,
                onInvite: this._onInvite,
                onRevoke: this._onRevoke,
                onClose: this.onCancelTriggered.bind(this),
                i18nModule: this._i18nModule
            })
        );

        this._reactRoot = root;
    },

    onAfterPageShow: function() {
        // Render React component after popup is shown
        this._renderReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default ProjectSharePopupView;
